import { FETCH_CUSTOMER_LIST, FETCH_CUSTDETAIL_LIST, FETCH_All_Account_Manager, FETCH_Muvi_Account_Manager, FETCH_All_Muvi_Six, FETCH_Muvi_Six_Customer ,FETCH_Muvi_Six_Customer_SearchHandler,FETCH_Load_More,FETCH_Load_More1,FETCH_Load_More2 ,FETCH_Pagination_Handel,FETCH_Muvi6_Login,FETCH_Assign_Acc,FETCH_Save_Account_Manager,FETCH_Savepassword,FETCH_CancelAccountMuvi5,FETCH_Raise_Invoice,FETCH_Product_By_Key,FETCH_Muvi_Classic_Count} from "../actions/type";

const initialState = {
    customers: [],
    activePage: 1,
    item_count: '',
    from_date: '',
    to_date: '',
    search: '',
    message: '',
    customerdetails: '',
    studio_id: '',
    user_id: '',
    message: '',
    message1: '',
    check_account_manager: '',
    account_manager: [],
    account_manager_id: '',
    manager: '',
    manager_info: '',
    id: '',
    name: '',
    isLoadMore: 1,
    loading:true,
    keyaccount: '2',
    show: true,
    allmuvisix: [],
    muvisixproductkey: '',
    showMenu: false,
    popup: false,
    allEmployee: [],
    customerAppToken: '',
    accountName: '',
    allMuviAccountManager: [],
    offset: 0,
    muviFiveCount: null,
}

const customerListReducer = (state = initialState, action) => {
    const newState = {...state};
    switch (action.type) {
        case FETCH_CUSTOMER_LIST:
            return {
                ...state,
                customers: [...action.customers],
                item_count: action.item_count,
//                muviFiveCount: action.item_count,
//                store_permission: action.store_permission,
//                customer_success_permission : action.customer_success_permission,
//                is_general_user : action.is_general_user,
                package: action.package,
                offset: action.offset,
                off_count: action.off_count,
                setPage: 'yes',
                muvisixproductkey: '',
                loading:false
            }
            break;
        case FETCH_CUSTDETAIL_LIST:
            return {
                ...state,
                studio_id: [...action.studio_id],
                user_id: [...action.user_id],
                studio_id_id: action.studio_id_id,
                user_id_id: action.user_id_id,
                studio_id_name: action.studio_id_name,
                studio_email: action.studio_email,
                id: [...action.id] ? [...action.id] : '',
                account_manager: [...action.account_manager]

            }
            break;
        case FETCH_All_Account_Manager:
            return {
                ...state,
                allEmployee: [...action.allEmployee],
            }
            break;
        case FETCH_Muvi_Account_Manager:
            return {
                ...state,
                allMuviAccountManager: [...action.allMuviAccountManager],
            }
            break;
        case FETCH_All_Muvi_Six:
            return {
                ...state,
                allmuvisix: [...action.allmuvisix],
            }
            break;
        case FETCH_Muvi_Six_Customer:
            return {
                ...state,
                customers: [...action.customers],
                item_count: action.item_count,
                offset: action.offset,
                activePage: 1,
                muvisixproductkey: action.value,
                loading:false
            }
            break;
        case FETCH_Muvi_Six_Customer_SearchHandler:
            return {
                ...state,
                customers: [...action.customers],
            item_count: action.item_count,
            loading:false
            }
            break;
break;
        case FETCH_Load_More1:
            return {
                ...state,
                isLoadMore: action.isLoadMore
            }
            break;
        case FETCH_Load_More:
            return {
                ...state,
                customers: action.customers
            }
            break;
        case FETCH_Load_More:
            return {
                ...state,
                customers: action.customers
            }
            break;
        case FETCH_Pagination_Handel:
            return {
                ...state,
               customers: [...action.customers],
                    item_count: action.item_count,
                    offset: action.offset,
            }
            break;
        case FETCH_Muvi6_Login:
            return {
                ...state,
               user_data: action.findresponse
            }
            break;
        case FETCH_Assign_Acc:
            return {
                ...state,
                mssg: 'assign',
            }
            break;
        case FETCH_Save_Account_Manager:
            return {
                ...state,
                mssg: 'accmngrassign',
            }
            break;
        case FETCH_Savepassword:
            return {
                ...state,
                message: action.message
            }
            break;
        case FETCH_CancelAccountMuvi5:
            return {
                ...state,
                message1: action.message1,
            }
            break;
        case FETCH_Raise_Invoice:
            return {
                ...state,
                code: action.code,
                message: action.message,
            }
            break;
        case FETCH_Product_By_Key:
            return {
                ...state,
                customers: action.customers,
                item_count: action.item_count,
            }
            break;
        case FETCH_Muvi_Classic_Count:
            return {
                ...state,
                muviFiveCount: action.muviFiveCount,
            }
        default:
            break;
    }
    return newState;
}

export { customerListReducer }


// WEBPACK FOOTER //
// ./src/reducers/customerListReducer.js